import * as React from "react";
import {Product} from "../types";
import {View, ViewContent} from "@variocube/cube-ui";
import {ProductTable} from "./ProductTable";
import {VendingViewHeader} from "../header";
import {Inventory} from "../inventory";
import {useLocalization} from "../../i18n";

interface ListProductsViewProps {
    products: Product[];
    inventory: Inventory;
    onSelectProduct: (product: Product) => void;
    onCancel: () => void;
}

export function ListProductsView({products, inventory, onSelectProduct, onCancel}: ListProductsViewProps) {
    const {t} = useLocalization();
    return (
        <View>
            <VendingViewHeader title={t("AdminProductList")} button={t("Logout")} onButtonClick={onCancel}/>
            <ViewContent>
                <ProductTable products={products} inventory={inventory} onSelectProduct={onSelectProduct}/>
            </ViewContent>
        </View>
    );
}
